export default "__VITE_ASSET__COehNtkE__"